import { useMemo } from 'react';

import styles from './styles.module.css';
import { createLubeColumns, createLubeRows } from './utils';
import { StatusIndicatorWithStyles } from '../ControlTab/utils';
import DataTable from '@/components/DataTable';
import EmptyState from '@/components/EmptyState';
import GridContainer from '@/components/GridContainer';
import { getLubePath } from '@/solaris-lens-common-lib/src/utils/turbinesPaths';

const lubeColumns = createLubeColumns(StatusIndicatorWithStyles);

export default function LubeTab({ turbineData }: { turbineData: any }) {
  const initialData = useMemo(() => {
    if (turbineData) {
      return getLubePath(turbineData) || {};
    }
    return {};
  }, [turbineData]);

  const lubeRows = useMemo(() => createLubeRows(initialData), [initialData]);

  if (lubeRows.length === 0) {
    return (
      <EmptyState
        title="No data available"
        subtitle="No data available for this tab."
      />
    );
  }

  return (
    <GridContainer gap="0px" align="left" minItemWidth="600px">
      <DataTable
        title="Mode"
        rows={lubeRows}
        columns={lubeColumns}
        type="detail"
        getRowId={row => row.key}
        noLeftMargin={true}
        alignTextLeft={true}
        className={styles.controlTable}
      />
    </GridContainer>
  );
}
